import {UserEntity} from './user.entity';
import {UserDto} from './dto/user.dto'
export const toUserDto = (data: UserEntity): UserDto => {  
  const { id, username, mobileNumber, email, employeeRole, unitId, versionFlag } = data;
  let userDto: UserDto = { id, username, mobileNumber, email, employeeRole, unitId, versionFlag };
  return userDto;
};